import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';

import { IconButton } from 'src/components/helpers/IconButton';
import Button from '../../../helpers/Button';

const AgreementCategoriesComponent = ({
  agreementCategories,
  onSelectAgreementCategories,
  onAgreementLink,
  onAgreementUnlink,
}) => {
  const handleAgreementUnlink = id => {
    const updatedAgreementCategories = agreementCategories.map(agreementCategory => {
      const item = Map.isMap(agreementCategory) ? agreementCategory.toJS() : agreementCategory;

      return {
        ...item,
        children: item.children.map(child => {
          if (child.id === id) {
            return {
              ...child,
              linkedAgreementBuyerId: null,
              linkedAgreementBuyerName: null,
              linkedAgreementId: null,
              linkedAgreementName: null,
            };
          }

          return child;
        }),
      };
    });

    onAgreementUnlink(updatedAgreementCategories);
  };

  return (
    <>
      <div className="form-group">
        <b>
          Agreement Categories
          <IconButton
            className="ml5"
            icon="edit"
            onClick={onSelectAgreementCategories}
            size="sm"
            title="Edit agreement categories"
          />
        </b>
      </div>
      {agreementCategories?.map(agreementCategory => (
        <div key={agreementCategory.id} className="form-group pl20">
          <b>{agreementCategory.category}</b>
          <ul className="list-unstyled pl20">
            {agreementCategory.children?.map(child => (
              <li key={child.id}>
                {child.category}
                {child.isLinkable && (
                  <>
                    <IconButton
                      className="ml5"
                      icon="reply"
                      onClick={() => onAgreementLink(child)}
                      size="sm"
                      title="Link an Agreement"
                    />
                    {child.linkedAgreementBuyerId !== null && child.linkedAgreementId !== null && (
                      <Link
                        className={child.linkedAgreementDeletedAt !== null && 'unclickable disabled-link'}
                        target="_blank"
                        to={`/company/${child.linkedAgreementBuyerId}/buyer/retainer#agreementId_${child.linkedAgreementId}`}
                      >
                        {child.linkedAgreementBuyerName}({child.linkedAgreementName})
                      </Link>
                    )}
                    {child.linkedAgreementBuyerId !== null && child.linkedAgreementId !== null && (
                      <Button
                        className="ml5 btn-link c-black font-bold"
                        onClick={() => handleAgreementUnlink(child.id)}
                      >
                        Unlink
                      </Button>
                    )}
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

/** Agreements categories component. */
export const AgreementCategories = memo(AgreementCategoriesComponent);
